import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class CarOrderDetailsResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.avaiableDrivers = [];
    }
    pk() {
        return this.applicationId?.toString();
    }
}
CarOrderDetailsResource.urlRoot = legacyApiResourceUrl("CarOrder/Details");
//# sourceMappingURL=CarOrderResources.js.map